var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeCrossLineGray400Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#888888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60005 4.15332C3.30672 4.37332 3.03805 4.60532 2.79339 4.84132C1.97628 5.63489 1.29979 6.56138 0.792719 7.58132C0.729577 7.71174 0.696777 7.85476 0.696777 7.99966C0.696777 8.14455 0.729577 8.28757 0.792719 8.41799C1.29952 9.43812 1.97579 10.3648 2.79272 11.1587C3.96005 12.282 5.67872 13.3333 8.00005 13.3333C9.49072 13.3333 10.7334 12.9 11.7401 12.292L9.11072 9.66332C8.72599 9.92031 8.26407 10.036 7.80364 9.99058C7.34321 9.9452 6.91276 9.74159 6.58561 9.41444C6.25845 9.08729 6.05485 8.65683 6.00946 8.1964C5.96408 7.73597 6.07973 7.27405 6.33672 6.88932L3.60072 4.15266L3.60005 4.15332ZM13.7774 10.5587C14.3442 9.9099 14.8249 9.19061 15.2074 8.41866C15.2705 8.28824 15.3033 8.14522 15.3033 8.00032C15.3033 7.85542 15.2705 7.71241 15.2074 7.58199C14.7006 6.56186 14.0243 5.63514 13.2074 4.84132C12.0401 3.71799 10.3221 2.66666 8.00005 2.66666C7.36814 2.66482 6.73873 2.74619 6.12805 2.90866L13.7774 10.5587Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossLineGray400Icon);
export default __webpack_public_path__ + "static/media/eye_cross_line_gray400_icon.ebdae8f477a41b84ccf08dc7415ca89a.svg";
export { ForwardRef as ReactComponent };